const RouteData = {
  data() {
    return {
      TeacherRouteData: ["/Teacher/classlist", "/Teacher/experimentManage", "/Teacher/reportManage", "/Teacher/datacenter", "/Teacher/case", "/Teacher/To_examine"],
      AdminRouteData: ["/Teacher/userlist", "/Teacher/classlist", "/Teacher/experimentManage", "/Teacher/reportManage", "/Teacher/datacenter", "/Teacher/case"],
      // eslint-disable-next-line global-require,import/no-unresolved
      logo: require("../../public/static/logo/logo.png")
    };
  }
};

export default RouteData;
